export default "__VITE_ASSET__SxSK9ivC__"